import * as React from "react";

const CloseIcon = (props) => {
  return (
    <>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width={24}
          height={24}
          fill="none"
          {...props}
        >
          <path
            fill="#64748B"
            d="M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12C23.993 5.376 18.625.007 12 0Zm4 14.587A1 1 0 1 1 14.587 16L12 13.414 9.414 16A1 1 0 0 1 8 14.586L10.586 12 8 9.414A1 1 0 0 1 9.414 8L12 10.586 14.587 8A1 1 0 1 1 16 9.413L13.414 12 16 14.587Z"
          />
        </svg>
    </>
  );
};
export default CloseIcon;
